import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles, Tooltip } from "@material-ui/core";

import { ReactComponent as GreyCross } from "../../../Icons/GreyCross.svg";
import { loadArabicImage } from "../../../components/IFormDesignerLayout/IFormDesignerLogic";

const GridModalHeader = (props) => {
  const useStylesGridHeader = makeStyles(() => ({
    tooltip: {
      maxWidth: "260px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      color: "black",
      border: "#70707075 1px solid",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
      fontSize: 12
    },
    arrow: {
      "&:before": {
        border: "1px solid #70707075"
      },
      color: "white",
      fontSize: 15
    },
    container: {
      borderBottom: (style) => style.shouldShowHeader ? (props.modalType === "modal" || props.modalType === "Through Popup")? "1px solid rgb(196, 196, 196)":"1px solid #C4C4C4" : null,
      backgroundColor: (style) =>
        style.shouldShowHeader
          ? style.popupStyle["AdvListviewHeaderBackgroundColor"] || "#fff"
          : style.popupStyle["AdvListviewBackgroundColor"] || "#fff",
      display: "flex",
      justifyContent: (style) => style.shouldShowHeader ? "space-between" : "end",
      fontFamily: "Open Sans",
      fontWeight: "600",
      fontSize: "14px",
      width: "100%",
      alignItems: "center",
      height: "45px",
      minHeight: "50px",
      padding: "0 16px",
      zIndex: "1301"
    },
    headerImage: {
      width: (style) => style.popupStyle["AdvListviewHeaderFontSize"] || "16px",
      minWidth: (style) => style.popupStyle["AdvListviewHeaderFontSize"] || "16px",
      height: (style) => style.popupStyle["AdvListviewHeaderFontSize"] || "16px",
      marginRight: "10px"
    },
    titleContainer: { display: "flex", alignItems: "center" },
    headerTitle: {
      display: "-webkit-box",
      WebkitLineClamp: 1,
      wordBreak: "break-word",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      paddingRight: "16px",
      fontFamily: (style) => style.popupStyle["AdvListviewHeaderFontFamily"] || "Open Sans",
      fontWeight: (style) => style.popupStyle["AdvListviewHeaderFontWeight1"] || "normal",
      fontStyle: (style) => style.popupStyle["AdvListviewHeaderFontStyle"] || "normal",
      color: (style) => style.popupStyle["AdvListviewHeaderFontColor"] || "#606060",
      fontSize: (style) => style.popupStyle["AdvListviewHeaderFontSize"] || "16px"
    },
    headerBatchBtn: { display: "flex", alignItems: "center", gap: "16px" },
    colSelectContainer: { fontSize: "12px" },
    colSelect: {
      marginLeft: "10px !important",
      width: "50px",
      height: "30px !important",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      border: "1px solid #E1E1E1 !important",
      borderRadius: "2px !important",
      opacity: "1"
    },
    crossButton: {
      width: "12px",
      height: "12px",
      position: "relative",
      cursor: (style) => (style.isViewer ? "pointer" : "not-allowed")
    }
  }));

  const { gridJSON = {}, imageBaseURL = "", isViewer, extraProps = {} } = props;
  const { popupStyle = {} } = gridJSON;
  const { handleCol, handleClose } = extraProps;

  const isListview = gridJSON.elem_type === "listview";
  const idKey = isListview ? "listview" : "advListview";
  const shouldShowHeader = gridJSON?.popupStyle?.["Header"] === "true" || gridJSON?.popupStyle?.["Header"] === undefined;

  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const { t } = useTranslation();
  const classes = useStylesGridHeader({ popupStyle, isViewer, shouldShowHeader });

  const showLegacyId = window?.psh_configs?.show_legacy_ids === "Y"

  return (
    <div className={classes.container}>
      {shouldShowHeader ? (
        <span className={classes.titleContainer}>
          {popupStyle["iconFile"] ? (
            <img
              className={classes.headerImage}
              alt="advance listview header"
              src={`${imageBaseURL}${popupStyle["iconFile"]}${loadArabicImage(imageBaseURL)}`}
            />
          ) : null}

          <span
            id={`${gridJSON.id}_${idKey}_label`}
            title={popupStyle["AdvlistviewTitle"] || gridJSON.style?.Label}
            className={classes.headerTitle}
          >
            {popupStyle["AdvlistviewTitle"] || gridJSON.style?.Label}
          </span>
        </span>
      ) : null}

      <span className={classes.headerBatchBtn}>
        {isListview && !isViewer ? (
          <div
            className={classes.colSelectContainer}
            style={translationStyles1 ? { marginLeft: "unset", marginRight: "auto" } : {}}
          >
            {t("COL")}
            <select
              id="col-Selection"
              className={classes.colSelect}
              onChange={() => handleCol("col-Selection")}
              value={gridJSON.listviewFrameLayoutJson.children[0].children[0].ColumnLayout}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="6">6</option>
              <option value="12">12</option>
            </select>
          </div>
        ) : null}
          {
            (props.modalType === 'modal' || props.modalType === "Through Popup") &&
        <Tooltip
          title={isViewer ? t("Close") : t("Read_only_actions")}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          placement={"bottom-start"}
          arrow
        >
          <GreyCross
            className={classes.crossButton}
            onClick={isViewer ? handleClose : null}
            onKeyDown={(e) => e.key === "Enter" && isViewer && handleClose()}
            alt="Close Icon"
            aria-label="Close Icon"
            id={showLegacyId ? `${gridJSON.id}_${idKey}_crossIcon` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_crossIcon`}
            tabIndex={isViewer ? 0 : -1}
          />
        </Tooltip>
          }
      </span>
    </div>
  );
};

export default GridModalHeader;
